import React from 'react'

export default function OverviewEmpty({ message, title }) {
  return (
    <div className="overview-empty">
      {title ? <h3 className="overview-empty-title">{title}</h3> : null}
      <p>
        {message ||
          'This home page shows only modules granted to your role. Use the sidebar to open tools you can access — restricted areas are never listed here.'}
      </p>
    </div>
  )
}
